import { authRoles } from './auth/authRoles'


export const navigations = [
    {
        name: 'Dashboard',
        path: '/dashboard/default',
        icon: 'dashboard'
    },
    {
        name: 'Members',
        icon: 'people',
        auth: authRoles.admin,
        requiredPermission: 'create_member',
        children: [
            {
                name: 'New',
                path: '/pages/new-customer/new',
                iconText: 'NC',
            },
            {
                name: 'Member List',
                path: '/pages/customer-list',
                iconText: 'ML',
            },
        ],
    },
    {
        name: 'Membership Plans',
        icon: 'wallet',
        auth: authRoles.admin,
        requiredPermission: 'manage_plans',
        children: [
            {
                name: 'All',
                path: '/pages/membership-plans',
                iconText: 'CL',
            },
            {
                name: 'New',
                path: '/pages/membership-plans/new',
                iconText: 'NC',
            }
        ]
    },
    {
        name: "Notice Board",
        icon: "notification_important",
        auth: authRoles.admin,
        path: '/pages/notice-board'
    },
    {
        name: "Email Analytics",
        icon: "email",
        auth: authRoles.admin,
        path: '/pages/email-analytics'
    },
    {
        name: "Transactions",
        icon: "receipt",
        auth: authRoles.admin,
        path: '/pages/transactions'
    }
]

export const navigationSA = [
    {
        name: 'Dashboard',
        path: '/dashboard/analytics',
        icon: 'analytics'
    },
    {
        name: 'Clubs',
        icon: 'people',
        auth: authRoles.sa,
        children: [
            {
                name: 'New Club',
                path: '/pages/new-client/new',
                iconText: 'NC',
            },
            {
                name: 'All Club List',
                path: '/pages/client-list',
                iconText: 'CL',

            },
        ],
    }
]

export const footerNavigationSA = [
    {
        name: 'Settings',
        icon: 'settings',
        path: '/settings/account-settings'
    }
]


